import { render, staticRenderFns } from "./bimBreadcrumbs.vue?vue&type=template&id=8c65e4fc&scoped=true&"
import script from "./bimBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./bimBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./bimBreadcrumbs.vue?vue&type=style&index=0&id=8c65e4fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c65e4fc",
  null
  
)

export default component.exports